import { shuffle } from 'es-toolkit';

import { cyrb53 } from './stableHash';

/**
 * 순수 순열 유틸. "어떤 순서로 섞을지"만 정하고, 정답·퀴즈 같은 도메인 판단은 하지 않는다.
 * 정답이 드러나는 배치를 거르는 일은 `@/shared/quiz/answerHidingShuffle` 이 이 위에서 한다.
 *
 * 둘 다 원본 배열을 바꾸지 않고 새 배열을 돌려준다.
 */

/** 부를 때마다 결과가 다른 무작위 셔플(`Math.random`). 브라우저에서만 그리는 화면용이다. */
export const randomShuffle = <T>(items: readonly T[]): T[] => shuffle(items);

/**
 * seed 가 같으면 언제 어디서 불러도 같은 순서를 내는 셔플. SSR 과 클라이언트가 같은 순서를
 * 그려야 하는 화면용이다(무작위면 hydration 불일치가 난다).
 *
 * 항목마다 `${seed}:${key}` 의 해시로 정렬한다. 해시가 문자열이라 **사전순으로 비교**한다 —
 * 비교 방식을 바꾸면 이미 노출된 순서가 전부 바뀐다.
 */
export const seededShuffle = <T>(
  items: readonly T[],
  getKey: (item: T) => string,
  seed: string,
): T[] =>
  items
    .map(item => ({ item, rank: cyrb53(`${seed}:${getKey(item)}`) }))
    .sort((a, b) => (a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : 0))
    .map(({ item }) => item);
